__turbopack_context__.v({
  "container": "-BgPFq_container",
  "gutterContent": "-BgPFq_gutterContent",
  "heading": "-BgPFq_heading",
  "headingsContainer": "-BgPFq_headingsContainer",
  "subheading": "-BgPFq_subheading",
});
